export type MockClient = {
  id: string;
  name: string;
  initials: string;
  color: string;
};

export const mockClients: MockClient[] = [
  { id: "client-1", name: "Fashion House Co.", initials: "FH", color: "bg-pink-600" },
  { id: "client-2", name: "TechStartup XYZ", initials: "TX", color: "bg-blue-600" },
  { id: "client-3", name: "Startup Ventures", initials: "SV", color: "bg-emerald-600" },
];

export type MockPost = {
  id: string;
  content: string;
  platform: string;
  status: "DRAFT" | "PENDING_APPROVAL" | "APPROVED" | "SCHEDULED" | "PUBLISHED";
  scheduledAt: Date;
  author: string;
  authorInitials: string;
  clientId: string;
  mediaUrl?: string;
  labels: { name: string; color: string }[];
  engagement?: { likes: number; comments: number; shares: number; reach: number };
};

export type MockTeamMember = {
  id: string;
  name: string;
  email: string;
  initials: string;
  role: string;
  avatar?: string;
  lastActive: string;
};

const today = new Date();
today.setHours(9, 0, 0, 0);
const d = (offset: number, hour = 9, minute = 0) => {
  const date = new Date(today);
  date.setDate(date.getDate() + offset);
  date.setHours(hour, minute, 0, 0);
  return date;
};

export const mockPosts: MockPost[] = [
  {
    id: "1",
    content: "Exciting news! We just launched our new summer collection. Check out the latest styles and trends that are perfect for the season. Link in bio! ☀️🛍️",
    platform: "INSTAGRAM",
    status: "PUBLISHED",
    scheduledAt: d(-3, 10, 30),
    author: "Sarah Chen",
    authorInitials: "SC",
    clientId: "client-1",
    mediaUrl: "/posts/post-1.jpg",
    labels: [{ name: "Campaign", color: "#8b5cf6" }, { name: "Product Launch", color: "#06b6d4" }],
    engagement: { likes: 1243, comments: 89, shares: 156, reach: 15420 },
  },
  {
    id: "2",
    content: "Behind the scenes at our latest photoshoot 📸 The team worked incredibly hard to bring this vision to life. Stay tuned for the full reveal!",
    platform: "INSTAGRAM",
    status: "SCHEDULED",
    scheduledAt: d(1, 14, 0),
    author: "Marcus Johnson",
    authorInitials: "MJ",
    clientId: "client-1",
    mediaUrl: "/posts/post-2.jpg",
    labels: [{ name: "Behind the Scenes", color: "#f59e0b" }],
  },
  {
    id: "3",
    content: "We are hiring! Looking for a Senior Marketing Manager to join our growing team. Remote-friendly, competitive salary, and amazing benefits. Apply now 👇",
    platform: "LINKEDIN",
    status: "APPROVED",
    scheduledAt: d(2, 11, 0),
    author: "Sarah Chen",
    authorInitials: "SC",
    clientId: "client-2",
    mediaUrl: "/posts/post-3.jpg",
    labels: [{ name: "Hiring", color: "#10b981" }],
  },
  {
    id: "4",
    content: "Hot take: The best marketing strategy is just being genuinely helpful. Stop selling, start solving. 🧵 Thread below on how we increased engagement 340% by shifting our approach...",
    platform: "TWITTER",
    status: "PENDING_APPROVAL",
    scheduledAt: d(3, 15, 30),
    author: "Alex Rivera",
    authorInitials: "AR",
    clientId: "client-2",
    mediaUrl: "/posts/post-4.jpg",
    labels: [{ name: "Thought Leadership", color: "#ec4899" }],
  },
  {
    id: "5",
    content: "5 tips to boost your social media presence this quarter:\n\n1. Consistency over perfection\n2. Engage with your audience daily\n3. Use analytics to guide decisions\n4. Collaborate with micro-influencers\n5. Repurpose your best content",
    platform: "LINKEDIN",
    status: "DRAFT",
    scheduledAt: d(4, 9, 0),
    author: "Marcus Johnson",
    authorInitials: "MJ",
    clientId: "client-3",
    mediaUrl: "/posts/post-5.jpg",
    labels: [{ name: "Tips", color: "#6366f1" }],
  },
  {
    id: "6",
    content: "Customer spotlight: See how @TechStartupXYZ grew their following by 200% in just 3 months using our platform. Full case study on our blog!",
    platform: "TWITTER",
    status: "SCHEDULED",
    scheduledAt: d(1, 16, 0),
    author: "Sarah Chen",
    authorInitials: "SC",
    clientId: "client-2",
    mediaUrl: "/posts/post-6.jpg",
    labels: [{ name: "Case Study", color: "#06b6d4" }, { name: "Social Proof", color: "#8b5cf6" }],
  },
  {
    id: "7",
    content: "Happy Monday! Start your week with intention and purpose. What is one goal you are committing to this week? Drop it in the comments! 💪",
    platform: "FACEBOOK",
    status: "PUBLISHED",
    scheduledAt: d(-1, 8, 0),
    author: "Alex Rivera",
    authorInitials: "AR",
    clientId: "client-3",
    mediaUrl: "/posts/post-7.jpg",
    labels: [{ name: "Engagement", color: "#f59e0b" }],
    engagement: { likes: 534, comments: 127, shares: 45, reach: 8320 },
  },
  {
    id: "8",
    content: "New blog post: The Ultimate Guide to Content Calendars for 2026. Learn how top brands plan their content months in advance. Read now on our website!",
    platform: "FACEBOOK",
    status: "SCHEDULED",
    scheduledAt: d(5, 12, 0),
    author: "Marcus Johnson",
    authorInitials: "MJ",
    clientId: "client-2",
    mediaUrl: "/posts/post-8.jpg",
    labels: [{ name: "Blog", color: "#10b981" }],
  },
  {
    id: "9",
    content: "Quick tutorial: How to create scroll-stopping Reels in under 10 minutes. Save this for later! 🎬",
    platform: "INSTAGRAM",
    status: "DRAFT",
    scheduledAt: d(6, 13, 0),
    author: "Alex Rivera",
    authorInitials: "AR",
    clientId: "client-1",
    mediaUrl: "/posts/post-9.jpg",
    labels: [{ name: "Tutorial", color: "#ec4899" }],
  },
  {
    id: "10",
    content: "Join us LIVE this Thursday at 2pm EST for a Q&A on social media strategy. Bring your questions! We will be covering everything from content creation to analytics.",
    platform: "LINKEDIN",
    status: "APPROVED",
    scheduledAt: d(3, 14, 0),
    author: "Sarah Chen",
    authorInitials: "SC",
    clientId: "client-3",
    mediaUrl: "/posts/post-10.jpg",
    labels: [{ name: "Event", color: "#f59e0b" }, { name: "Live", color: "#ef4444" }],
  },
];

export const mockTeam: MockTeamMember[] = [
  { id: "1", name: "Sarah Chen", email: "sarah@socialstandards.io", initials: "SC", role: "owner", lastActive: "Just now" },
  { id: "2", name: "Marcus Johnson", email: "marcus@socialstandards.io", initials: "MJ", role: "admin", lastActive: "5 min ago" },
  { id: "3", name: "Alex Rivera", email: "alex@socialstandards.io", initials: "AR", role: "member", lastActive: "1 hour ago" },
  { id: "4", name: "Jordan Lee", email: "jordan@socialstandards.io", initials: "JL", role: "member", lastActive: "3 hours ago" },
  { id: "5", name: "Taylor Kim", email: "taylor@socialstandards.io", initials: "TK", role: "viewer", lastActive: "Yesterday" },
];

export const platformIcons: Record<string, { label: string; color: string; bg: string }> = {
  INSTAGRAM: { label: "Instagram", color: "text-pink-600", bg: "bg-pink-50" },
  FACEBOOK: { label: "Facebook", color: "text-blue-600", bg: "bg-blue-50" },
  TWITTER: { label: "X / Twitter", color: "text-slate-800", bg: "bg-slate-100" },
  LINKEDIN: { label: "LinkedIn", color: "text-blue-700", bg: "bg-blue-50" },
  TIKTOK: { label: "TikTok", color: "text-black", bg: "bg-gray-100" },
};

export const statusConfig: Record<string, { label: string; color: string; bg: string; dot: string }> = {
  DRAFT: { label: "Draft", color: "text-gray-700", bg: "bg-gray-100", dot: "bg-gray-400" },
  PENDING_APPROVAL: { label: "Pending", color: "text-amber-700", bg: "bg-amber-50", dot: "bg-amber-400" },
  APPROVED: { label: "Approved", color: "text-green-700", bg: "bg-green-50", dot: "bg-green-500" },
  SCHEDULED: { label: "Scheduled", color: "text-blue-700", bg: "bg-blue-50", dot: "bg-blue-500" },
  PUBLISHED: { label: "Published", color: "text-emerald-700", bg: "bg-emerald-50", dot: "bg-emerald-500" },
  FAILED: { label: "Failed", color: "text-red-700", bg: "bg-red-50", dot: "bg-red-500" },
};

export type MockApprovalRequest = {
  id: string;
  postId: string;
  content: string;
  platform: string;
  author: string;
  authorInitials: string;
  client: string;
  clientInitials: string;
  clientEmail: string;
  status: "pending" | "approved" | "rejected" | "changes_requested";
  submittedAt: Date;
  respondedAt?: Date;
  note?: string;
  labels: { name: string; color: string }[];
  version: number;
  comments: { author: string; initials: string; text: string; time: string; isClient: boolean }[];
};

export const mockApprovals: MockApprovalRequest[] = [
  {
    id: "apr-1",
    postId: "4",
    content: "Hot take: The best marketing strategy is just being genuinely helpful. Stop selling, start solving. 🧵 Thread below on how we increased engagement 340% by shifting our approach...",
    platform: "TWITTER",
    author: "Alex Rivera",
    authorInitials: "AR",
    client: "David Park",
    clientInitials: "DP",
    clientEmail: "david@clientbrand.com",
    status: "pending",
    submittedAt: d(-1),
    labels: [{ name: "Thought Leadership", color: "#ec4899" }],
    version: 1,
    comments: [
      { author: "Alex Rivera", initials: "AR", text: "Drafted this thread based on our Q1 results. Let me know if the tone works for the brand!", time: "Yesterday at 3:15 PM", isClient: false },
    ],
  },
  {
    id: "apr-2",
    postId: "2",
    content: "Behind the scenes at our latest photoshoot 📸 The team worked incredibly hard to bring this vision to life. Stay tuned for the full reveal!",
    platform: "INSTAGRAM",
    author: "Marcus Johnson",
    authorInitials: "MJ",
    client: "Lisa Chen",
    clientInitials: "LC",
    clientEmail: "lisa@fashionhouse.co",
    status: "pending",
    submittedAt: d(-2),
    labels: [{ name: "Behind the Scenes", color: "#f59e0b" }],
    version: 2,
    comments: [
      { author: "Marcus Johnson", initials: "MJ", text: "Updated with the new photos from the shoot. Version 2 addresses your feedback on image quality.", time: "2 days ago at 11:00 AM", isClient: false },
      { author: "Lisa Chen", initials: "LC", text: "Much better! Can we adjust the caption to mention the designer by name?", time: "2 days ago at 2:30 PM", isClient: true },
      { author: "Marcus Johnson", initials: "MJ", text: "Good call, updated the caption. Please review again!", time: "Yesterday at 9:00 AM", isClient: false },
    ],
  },
  {
    id: "apr-3",
    postId: "8",
    content: "New blog post: The Ultimate Guide to Content Calendars for 2026. Learn how top brands plan their content months in advance. Read now on our website!",
    platform: "FACEBOOK",
    author: "Marcus Johnson",
    authorInitials: "MJ",
    client: "David Park",
    clientInitials: "DP",
    clientEmail: "david@clientbrand.com",
    status: "changes_requested",
    submittedAt: d(-4),
    respondedAt: d(-3),
    note: "The CTA feels too pushy. Can we soften it to something like \"Explore the guide\" instead of \"Read now\"? Also, let us add a stat or teaser from the blog to make it more compelling.",
    labels: [{ name: "Blog", color: "#10b981" }],
    version: 1,
    comments: [
      { author: "Marcus Johnson", initials: "MJ", text: "Blog post is live — here is the social copy for Facebook.", time: "4 days ago at 10:00 AM", isClient: false },
      { author: "David Park", initials: "DP", text: "The CTA feels too pushy. Can we soften it to something like \"Explore the guide\" instead of \"Read now\"? Also, let us add a stat or teaser from the blog.", time: "3 days ago at 4:15 PM", isClient: true },
    ],
  },
  {
    id: "apr-4",
    postId: "10",
    content: "Join us LIVE this Thursday at 2pm EST for a Q&A on social media strategy. Bring your questions! We will be covering everything from content creation to analytics.",
    platform: "LINKEDIN",
    author: "Sarah Chen",
    authorInitials: "SC",
    client: "Rachel Torres",
    clientInitials: "RT",
    clientEmail: "rachel@startupventures.io",
    status: "approved",
    submittedAt: d(-5),
    respondedAt: d(-4),
    note: "Looks great, love the interactive format! Go ahead and schedule it.",
    labels: [{ name: "Event", color: "#f59e0b" }, { name: "Live", color: "#ef4444" }],
    version: 1,
    comments: [
      { author: "Sarah Chen", initials: "SC", text: "LinkedIn Live event post — targeting Thursday audience for max engagement.", time: "5 days ago at 9:00 AM", isClient: false },
      { author: "Rachel Torres", initials: "RT", text: "Looks great, love the interactive format! Go ahead and schedule it.", time: "4 days ago at 11:30 AM", isClient: true },
    ],
  },
  {
    id: "apr-5",
    postId: "1",
    content: "Exciting news! We just launched our new summer collection. Check out the latest styles and trends that are perfect for the season. Link in bio! ☀️🛍️",
    platform: "INSTAGRAM",
    author: "Sarah Chen",
    authorInitials: "SC",
    client: "Lisa Chen",
    clientInitials: "LC",
    clientEmail: "lisa@fashionhouse.co",
    status: "approved",
    submittedAt: d(-7),
    respondedAt: d(-6),
    note: "Perfect. On brand and ready to go!",
    labels: [{ name: "Campaign", color: "#8b5cf6" }, { name: "Product Launch", color: "#06b6d4" }],
    version: 3,
    comments: [
      { author: "Sarah Chen", initials: "SC", text: "Final version with updated product shots and revised copy.", time: "7 days ago at 2:00 PM", isClient: false },
      { author: "Lisa Chen", initials: "LC", text: "Perfect. On brand and ready to go!", time: "6 days ago at 10:00 AM", isClient: true },
    ],
  },
  {
    id: "apr-6",
    postId: "3",
    content: "We are hiring! Looking for a Senior Marketing Manager to join our growing team. Remote-friendly, competitive salary, and amazing benefits. Apply now 👇",
    platform: "LINKEDIN",
    author: "Sarah Chen",
    authorInitials: "SC",
    client: "David Park",
    clientInitials: "DP",
    clientEmail: "david@clientbrand.com",
    status: "rejected",
    submittedAt: d(-6),
    respondedAt: d(-5),
    note: "We decided to hold off on this role for now. Please archive this post — we will revisit hiring in Q3.",
    labels: [{ name: "Hiring", color: "#10b981" }],
    version: 1,
    comments: [
      { author: "Sarah Chen", initials: "SC", text: "Hiring post for the Senior Marketing Manager role as discussed.", time: "6 days ago at 11:00 AM", isClient: false },
      { author: "David Park", initials: "DP", text: "We decided to hold off on this role for now. Please archive this post — we will revisit hiring in Q3.", time: "5 days ago at 3:00 PM", isClient: true },
    ],
  },
];

export const approvalStatusConfig: Record<string, { label: string; color: string; bg: string; dot: string }> = {
  pending: { label: "Awaiting Approval", color: "text-amber-700", bg: "bg-amber-50", dot: "bg-amber-400" },
  approved: { label: "Approved", color: "text-green-700", bg: "bg-green-50", dot: "bg-green-500" },
  rejected: { label: "Rejected", color: "text-red-700", bg: "bg-red-50", dot: "bg-red-500" },
  changes_requested: { label: "Changes Requested", color: "text-orange-700", bg: "bg-orange-50", dot: "bg-orange-400" },
};

export const roleConfig: Record<string, { label: string; color: string; bg: string }> = {
  owner: { label: "Owner", color: "text-purple-700", bg: "bg-purple-50" },
  admin: { label: "Admin", color: "text-blue-700", bg: "bg-blue-50" },
  member: { label: "Member", color: "text-green-700", bg: "bg-green-50" },
  viewer: { label: "Viewer", color: "text-gray-600", bg: "bg-gray-100" },
};
